The active relationship types between the requesting partner and the hirer.

Currently, the following relationship type codes are defined:

- `ApplicationExport` enables exporting candidate applications from SEEK's Apply Form.

- `ApplicationPrefill` enables retrieving candidate profile data to pre-fill an external apply form.

- `JobPosting` enables posting job ads to the SEEK job board.

- `ProactiveSourcing` enables hirers to proactively search for and connect with suitable candidates.

- `CandidateProfiles` enables hirers to display the Candidate Profile Panel and query for SEEK Candidate Profiles.

- `CandidateVerification` enables hirers to request verification of candidates with SEEK Pass and query candidate identity verifications.
